import React, { useEffect } from "react";
import TrackOrder from "../../components/track-order/TrackOrder";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";

function TrackOrderPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumb title="Track Order" t={t} />
      <TrackOrder />
    </>
  );
}

export default TrackOrderPage;
